import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReactiveFormsModule } from '@angular/forms';
import {
  PropertyUsp2xPhotoInitModel,
  PropertyUsp2xPhotoInitVariables,
  PropertyUsp2xPhotoModel,
  PropertyUsp2xPhotoVariables,
} from '../../../../../models/email-template/property-usp-2x-photo.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-propertyusp2xphoto',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './property-usp-2x-photo.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './property-usp-2x-photo.component.scss'
})
export class PropertyUsp2xPhotoComponent extends BaseComponent implements OnInit {

  @Input() block: PropertyUsp2xPhotoModel = new PropertyUsp2xPhotoInitModel();
  @Input() isPreview = false;
  count: number = 0;
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new PropertyUsp2xPhotoInitVariables()
    }
  }

  //placeholders:
  image1Placeholder: string = 'First Image';
  image2Placeholder: string = 'Second Image';
  image1HrefPlaceholder: string = 'Enter First Image Redirect Link';
  image2HrefPlaceholder: string = 'Enter Second Image Redirect Link';
  image1AltPlaceholder: string = 'Enter First Image Alt Text';
  image2AltPlaceholder: string = 'Enter Second Image Alt Text';
  namePlaceholder: string = 'Enter Name';
  usp1Placeholder: string = 'Enter USP 1';
  usp2Placeholder: string = 'Enter USP 2';
  usp3Placeholder: string = 'Enter USP 3';
  ctaLinkPlaceholder: string = 'Enter CTA Link';
  ctaTextPlaceholder: string = 'Enter CTA Text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof PropertyUsp2xPhotoVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof PropertyUsp2xPhotoVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
